import { useI18n } from '../i18n';

export default function About() {
  const { t } = useI18n();

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">{t('about.title')}</h1>
      <div className="bg-white shadow-md rounded-lg p-6">
        <p className="text-gray-700 mb-4">
          {t('about.description')}
        </p>
        <p className="text-gray-700 mb-4">
          {t('about.contactPrompt')} <a href="mailto:moetv@mutse.top" className="text-blue-600 hover:underline">moetv@mutse.top</a>.
        </p>
        <p className="text-gray-700">
          {t('about.thanks')}
        </p>
      </div>
    </div>
  );
}
